
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"m15.005 10.982-4.138 4.011-1.88-1.851"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M10.956 10.497a5.9 5.9 0 0 0-3.21-.992 5.9 5.9 0 0 0-3.237.915 5.46 5.46 0 0 0-2.119 2.497M7.506 9.493a3.491 3.491 0 1 0 0-6.983 3.491 3.491 0 0 0 0 6.983Z"}})])
          )
        }
      }
    